const TopBarBanner = ({text}) => {
    return (
        <div className="top-bar-banner">
            <div className="container">
                <p>{text}</p>
            </div>
        </div>
    );
}

export default TopBarBanner;